import moment from "moment";
import { FormValidationRule } from "../../forms/types";
import { parseDateFormat } from "../../forms/helper";

const minDate: FormValidationRule = (c, v) => {
    let valid = true;
    let message = "";

    if (c.min_date && v) {
        const value = moment(v, "YYYY-MM-DD");
        const min = moment(c.min_date, "DD/MM/YYYY");
        const dateFormat = c.dateFormat || "dmy";

        if (value.isBefore(min)) {
            valid = false;
            message = `Please select a date after ${min
                .add(-1, "days")
                .format(parseDateFormat(dateFormat).toUpperCase())}.`;
        }
    }

    return [valid, message];
};

export default minDate;
